import { createRoot } from "react-dom/client";
import React from "react";
import ProjectPresenter from "./projectPresenter";
import AboutView from "../view/aboutmeView";
import Resume from "../view/resumeView";
import Home from "../view/homeView";
import { Header } from "../view/headerView";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/projects"
          element={<ProjectPresenter projectType="technical" />}
        />
        <Route
          path="/design-prototypes"
          element={<ProjectPresenter projectType="design" />}
        />
        <Route path="/resume" element={<Resume />} />
        <Route path="/about_me" element={<AboutView />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
